// export const UserRole = Object.freeze({
//   viewer_general: 1,
//   viewer_student: 2,
//   editor_schedule: 3,
//   editor_classrooms: 4,
//   editor_teachers: 5,
//   admin: 6
// })

export const UserRole = Object.freeze({
  viewer_general: 'viewer_general',
  viewer_student: 'viewer_student',
  editor_schedule: 'editor_schedule',
  editor_classrooms: 'editor_classrooms',
  editor_teachers: 'editor_teachers',
  admin: 'admin'
})
